import styles from "./index.module.scss";
import {
  MoreButton,
} from "@/components";

const MainOperation = () => {
  return (
    <div
      className={styles["main_operation"]}
    >
      <MoreButton
      ></MoreButton>
    </div>
  )
}

export default MainOperation;